<template>
  <b-overlay :show="filmCommentBusy">
    <!--Begin:: App Content-->
    <div class="kt-grid__item kt-grid__item--fluid kt-app__content mb-3" id="kt_chat_content">
      <div class="kt-chat">
        <div class="kt-portlet kt-portlet--head-lg kt-portlet--last">
          <div class="kt-portlet__head">
            <div class="kt-chat__head ">
              <div class="kt-chat__left">
                <b-avatar class="mr-3" rounded size="50px" :src="film_image" text="!"></b-avatar>
                <span class="mr-auto cursor-default">{{ film_title || 'نامەلۇم' }}</span>
              </div>
              <!--<div class="kt-chat__center">
                <div class="kt-chat__label mb-1">
                  <a class="kt-chat__title cursor-default">{{ film_title || 'نامەلۇم' }}</a>
                </div>
                <div class="kt-chat__pic kt--hidden">
                  <b-avatar-group>
                    <b-avatar v-for="comment in film_comments_list" :key="comment.id" class="kt-media kt-media&#45;&#45;sm kt-media&#45;&#45;circle" :src="comment.commenter.avatar" :title="comment.commenter.nickname" v-b-tooltip></b-avatar>
                  </b-avatar-group>
                </div>
              </div>-->
              <div class="kt-chat__right">
                <b-avatar-group>
                  <b-avatar v-for="comment in film_comments_list" :key="comment.id" class="kt-media kt-media--sm kt-media--circle" :src="comment.commenter.avatar" :title="comment.commenter.nickname" v-b-tooltip></b-avatar>
                </b-avatar-group>
              </div>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div v-for="comment in film_comments_list" :key="comment.id" @click="onClickComment(comment.id)" class="commenter-item d-flex px-3 py-3 mb-2">
              <div class="comment-icon mr-2" @click.stop="onChangeSwitch( comment.id, 'approved', $event )" v-if="!comment.approved" title="تەستىقلاش" v-b-tooltip><i class="flaticon-star"></i></div>
              <div class="comment-icon mr-2 approved" @click.stop="onChangeSwitch( comment.id, 'approved', $event )" v-else title="تەستىقنى بىكار قىلىش" v-b-tooltip><i class="flaticon-star"></i></div>
              <div class="comment-content mr-2 text-truncate ">{{ comment.comment }}</div>
              <div class="comment-time-ago mr-2">{{ comment.created_at }}</div>
              <b-avatar class="comment-commenter-avatar" size="30px" v-if="comment.comment_no_approved_counts" :src="comment.commenter.avatar" :title="comment.commenter.nickname" v-b-tooltip rounded="" :badge="`${comment.comment_no_approved_counts}`" badge-top badge-offset="-4px" badge-variant="warning" />
              <b-avatar class="comment-commenter-avatar" size="30px" v-else :src="comment.commenter.avatar" :title="comment.commenter.nickname" v-b-tooltip rounded="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination :meta="film_comments_meta" :implementSearch="false" @refresh="onRefresh" @change-page="onChangePage" />
    <!--End:: App Content-->
  </b-overlay>
</template>

<script>
  import pagination from "@v@/components/paginate";
  import commentMixin from "@m@/comment.mixin";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import commonMethodMixin from "@m@/common/common.method.mixin";
  import { mapGetters } from "vuex";
  import {SET_COMMENT_DETAIL, SET_COMMENT_ERROR} from "@/store/modules/comment.module";
  export default {
    name: "index",
    components: {pagination},
    mixins: [commentMixin, formBusyMixin, commonMethodMixin],
    computed: {
      ...mapGetters(['film_comments_list', 'film_comments_meta', 'film_title', 'film_image', 'comments_error'])
    },
    data(){
      return {
        filmCommentBusy: false,
        comments: [
          {
            comment: `ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى`,
            time_ago: `5 مىنۇت ئىلگىرى`,
            avatar: `assets/media/users/100_4.jpg`,
            nickname: `پالانى`,
            id: 1
          },
          {
            comment: `ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى، ئىنكاس مەزمۇنى`,
            time_ago: `10 مىنۇت ئىلگىرى`,
            avatar: `assets/media/users/300_11.jpg`,
            nickname: `پۇكۇنى`,
            id: 2
          }
        ]
      }
    },
    props: {
      id: {
        type: [String, Number]
      }
    },
    created() {
      this.getFilmComments(this.id);
    },
    watch:{
      "id": {
        handler(v, ov){
          if( v !== ov ){
            this.getFilmComments(v);
          }
        }
      }
    },
    methods: {
      onClickComment(comment_id){
        this.$router.push({name: 'comment.detail', params: { id: comment_id }})
      },
      onChangePage(e){
        let { page } = e;
        this.getFilmComments(this.id, page);
      },
      onRefresh(){
        this.getFilmComments(this.id, 1);
      },
      onChangeSwitch(id, column, value){
        this.switchColumn({
          resource: 'films/comments',
          id, column, mutationType: SET_COMMENT_ERROR,
          begin: ()=>{ this.showBusy('filmCommentBusy') },
          after: ()=>{ this.hideBusy('filmCommentBusy') },
        }).then((res)=>{
          this.getFilmComments(this.id, this.page);
        })
      },
    }
  }
</script>

<style scoped>
  .b-avatar-group {
    display: flex;
    justify-content: center;
  }

  .kt-app .kt-app__content, .kt-app .kt-app__detail {
    margin-right: unset !important;
  }

  .commenter-item {
    height: 40px;
    align-items: center;
    box-sizing: content-box;
    border-radius: 5px;
    cursor: pointer;
  }

  .commenter-item:hover {
    background-color: #f8f9fa !important;
  }

  .commenter-item:last-child {
    margin-bottom: unset !important;
  }

  .commenter-item .comment-icon {
    padding-block-start: 3px;
    cursor: pointer;
  }

  .commenter-item .comment-icon i {
    transition-duration: .3s;
    color: #ebedf2;
    font-size: 18px;
  }

  .commenter-item .comment-icon.approved i {
    color: var(--green);
  }

  .commenter-item .comment-icon:hover i {
    color: var(--green);
    opacity: .5;
  }

  .commenter-item .comment-content {
    flex-grow: 1;
  }

  .commenter-item .comment-time-ago {
    width: 100px;
  }

  .kt-chat__left .b-avatar {
    width: 100% !important;
    max-width: 36px;
  }

  .kt-chat__right .b-avatar-group {
    justify-content: flex-end;
  }

</style>
